import { getUsersWithAnnotationsOnCurrentPage } from '../selectors/annotations';
import { User } from '../store/users';
import { viewSectionVisibilityToggle, viewUserAnnotations } from '../store/view';
import { ThunkActionVoid } from './thunkActions';

export function updateUserAnnotationVisibility(userEmailsWithAnnotationsVisible: readonly string[]) {
  return viewUserAnnotations({ userAnnotationsVisible: userEmailsWithAnnotationsVisible });
}

export function displayAnnotationsForUser(userEmail: string): ThunkActionVoid {
  return (dispatch, getState) => {
    const userEmailsWithAnnotationsVisible = getUsersWithAnnotationsOnCurrentPage(getState()).map(
      (user: User) => user.email,
    );

    if (!userEmailsWithAnnotationsVisible.includes(userEmail)) {
      userEmailsWithAnnotationsVisible.push(userEmail);
    }

    dispatch(updateUserAnnotationVisibility(userEmailsWithAnnotationsVisible));
  };
}

export function hideAnnotationsForUser(userEmail: string): ThunkActionVoid {
  return (dispatch, getState) => {
    const state = getState();
    let userEmailsWithAnnotationsVisible = getUsersWithAnnotationsOnCurrentPage(state).map((user: User) => user.email);

    if (userEmailsWithAnnotationsVisible.includes(userEmail)) {
      // Hide annotations for user requested
      userEmailsWithAnnotationsVisible = userEmailsWithAnnotationsVisible.filter((email) => email !== userEmail);
    }

    if (!userEmailsWithAnnotationsVisible.includes(state.logInData.loggedInUser!.email)) {
      // Make sure annotations for current user will always be shown
      userEmailsWithAnnotationsVisible.push(state.logInData.loggedInUser!.email);
    }

    dispatch(updateUserAnnotationVisibility(userEmailsWithAnnotationsVisible));
  };
}

export function toggleDocumentControlsVisibility() {
  return viewSectionVisibilityToggle({ section: 'document' });
}

export function toggleAnnotationsControlsVisibility() {
  return viewSectionVisibilityToggle({ section: 'annotations' });
}

export function toggleSealingControlsVisibility() {
  return viewSectionVisibilityToggle({ section: 'sealing' });
}

export function toggleOtherControlsVisibility() {
  return viewSectionVisibilityToggle({ section: 'other' });
}
